import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Youtube, MessageCircle, Video, Mail, Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black border-t border-gray-800 py-12 mt-auto" data-id="element-31">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-32">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12" data-id="element-33">
          {/* Brand Column */}
          <div className="space-y-4" data-id="element-34">
            <h3 className="text-lg font-bold text-white" data-id="element-35">ALEKS SZULC</h3>
            <p className="text-gray-400 text-sm leading-relaxed max-w-xs" data-id="element-36">
              Martial artist, coach, and content creator based in Warsaw.
              Helping you build strength, discipline, and confidence through
              personalized training.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4" data-id="element-37">
            <h4 className="font-semibold text-white" data-id="element-38">Quick Links</h4>
            <ul className="space-y-2 text-sm text-gray-400" data-id="element-39">
              <li data-id="element-40">
                <Link to="/training" className="hover:text-[#D4FF00] transition-colors" data-id="element-41">
                  Personal Training
                </Link>
              </li>
              <li data-id="element-42">
                <Link to="/socials" className="hover:text-[#D4FF00] transition-colors" data-id="element-43">
                  Social Content
                </Link>
              </li>
              <li data-id="element-44">
                <Link to="/about" className="hover:text-[#D4FF00] transition-colors" data-id="element-45">
                  About
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact & Social */}
          <div className="space-y-4" data-id="element-46">
            <h4 className="font-semibold text-white" data-id="element-47">Connect</h4>

            {/* Contact Info */}
            <div className="space-y-2" data-id="element-48">
              <a href="tel:+48536052998" className="flex items-center text-sm text-gray-400 hover:text-[#D4FF00] transition-colors" data-id="element-49">
                <Phone size={16} className="mr-2" data-id="element-50" />
                +48 536 052 998
              </a>
              <a href="mailto:contact@szulcaleks.com" className="flex items-center text-sm text-gray-400 hover:text-[#D4FF00] transition-colors" data-id="element-51">
                <Mail size={16} className="mr-2" data-id="element-52" />
                contact@szulcaleks.com
              </a>
            </div>

            {/* Social Links */}
            <div className="flex space-x-4 pt-2" data-id="element-53">
              <a href="https://www.instagram.com/aleks.szulc1/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-900 border border-gray-800 rounded-full flex items-center justify-center text-gray-400 hover:border-[#D4FF00] hover:text-[#D4FF00] transition-all" aria-label="Instagram" data-id="element-54">
                <Instagram size={20} data-id="element-55" />
              </a>
              <a href="https://www.tiktok.com/@aleks.szulc1" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-900 border border-gray-800 rounded-full flex items-center justify-center text-gray-400 hover:border-[#D4FF00] hover:text-[#D4FF00] transition-all" aria-label="TikTok" data-id="element-56">
                <Video size={20} data-id="element-57" />
              </a>
              <a href="https://youtube.com/@aleks.szulc1" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-900 border border-gray-800 rounded-full flex items-center justify-center text-gray-400 hover:border-[#D4FF00] hover:text-[#D4FF00] transition-all" aria-label="YouTube" data-id="element-58">
                <Youtube size={20} data-id="element-59" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-sm text-gray-500" data-id="element-60">
          <p data-id="element-61">
            &copy; {new Date().getFullYear()} Aleks Szulc. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}